/**
 * Shops page
 */
import { dispatch } from 'store';

import { FEATURED_USERS_ADD, FETCH_LIKED_USERS } from '../action-types/shops-page.action-types';

// eslint-disable-next-line import/prefer-default-export
export const saveShopsPageFeaturedUsers = (data) => dispatch({ type: FEATURED_USERS_ADD, data });
export const saveShopsPageLikedUsers = (data) => dispatch({ type: FETCH_LIKED_USERS, data });
